module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordCheck"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.upper === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.upper === false) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_inactive"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.upper === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.upper === true,
      error: _vm.passwordCheck.upper === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("upper case letter (A-Z)")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.lower === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.lower === false) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_inactive"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.lower === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.lower === true,
      error: _vm.passwordCheck.lower === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("lower case letter (a-z)")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.number === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.number === false) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_inactive"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.number === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.number === true,
      error: _vm.passwordCheck.number === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("number")]), _vm._v(" (0-9)")])])]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.special === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.special === false) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_inactive"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.special === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.special === true,
      error: _vm.passwordCheck.special === 'error'
    }
  }, [_c('strong', [_vm._v("1 special character")]), _vm._v(", e.g. "), _c('strong', [_vm._v("#?!@$%^&*")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.length === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.length === false) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_inactive"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.length === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.length === true,
      error: _vm.passwordCheck.length === 'error'
    }
  }, [_c('strong', [_vm._v("10+ characters")]), _vm._v(" in length")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-435fe81d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordStrengthValidation/PasswordStrengthValidation.vue
// module id = 3143
// module chunks = 1